import { useSelector } from 'react-redux';
import { RootState } from '@/lib/store';
import GameList from '@/components/core/Games/GameList';
import { useInfiniteDocumentScroll } from '@starsoft/common/hooks';
import { useGames } from '@/api/games';
import { useRouter } from 'next/router';
import { GameTagFilter } from '@/models/games/game-tag-filter.enum';

export default function CasinoGameList() {
  const { query } = useRouter();
  const tag: GameTagFilter | undefined = query.tag as GameTagFilter;

  const name: string = useSelector(
    (state: RootState) => state.casino.searchGame,
  );
  const providerIds: bigint[] = useSelector(
    (state: RootState) => state.casino.providersList,
  );

  const {
    games,
    error,
    isLoading,
    refetch,
    isFetchingNextPage,
    hasNextPage,
    fetchNextPage,
  } = useGames({
    limit: 50,
    query: name,
    providerIds,
    tag,
  });
  useInfiniteDocumentScroll({
    hasMore: hasNextPage ?? false,
    isLoading: (isLoading || isFetchingNextPage) ?? false,
    loadMore: fetchNextPage,
  });

  return (
    <GameList
      games={games ?? []}
      refetch={refetch}
      error={error}
      isFetchingNextPage={isFetchingNextPage}
      isLoading={isLoading}
    />
  );
}
